<template>
  <v-dialog
    v-model="planDialog"
    width="500px">
    <div class="dialog-container">
      <div class="plan-header">
        <div class="info flex">
          <span>Coupon Error</span>
          <i
            class="el-icon-close"
            @click="ConfirmCoupon"></i>
        </div>
      </div>
      <div class="dialog-body">
        <p class="color-danger">Your currently selected coupon is incompatible with the plan</p>
      </div>
      <div class="flex footer-button">
        <v-button
          plain
          @click="handleClearCoupon">
          <span class="color-danger">Clear Coupon</span>
        </v-button>
      </div>
    </div>
  </v-dialog>
</template>
<script>
import {mapState,mapActions } from 'vuex'
import OMath from '@/utils/math'
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'

export default {
  name: 'ReferCouponTipDialog',
  mixins: [MixinOptions, MixinFormat],
  props: {
  },
  data() {
    return {
      planDialog: false,
      coupon:''
    }
  },
  computed: {
    ...mapState('coupon', ['selectCode']),
  },
  methods: {
    ...mapActions('coupon', ['setSelectCode', 'setCouponData']),
    changeDialog(isCan) {
      this.planDialog = isCan
    },
    ConfirmCoupon(){
      this.planDialog =false
    },
    handleClearCoupon(){
      this.planDialog = false
      this.$emit('removeCoupon')
    }
  }
}
</script>
<style lang="scss" scoped>
  ::v-deep .el-dialog{
    border-radius: 4px;
  }
  .dialog-container {
    //padding: 15px;
    border-radius: 5px;
    .plan-header {
      background: #F6F8FA;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      padding: 5px 0;
      .info{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding:10px 10px 10px 10px;
        font-size: 14px;
        font-weight: 600;
        color: #24292E;
        i{
          font-weight: 600;
          font-size: 14px;
        }
      }
    }
    .dialog-body{
      padding: 15px;
      max-height: 500px;
      overflow-y: auto;
      .color-danger{
        font-size: 14px;
        font-weight: 600;
      }
    }
    .footer-button{
      padding: 15px;
      justify-content: flex-end;
      .el-button{
        width: 100%;
      }
    }
  }
</style>
